/**
 * Created by lihanying on 2017/7/10.
 */
import React from 'react'
import { DatePicker, Radio, Button, Spin } from 'antd'
import NineAndZeroRadio from '../../../components/nineAndZeroRadio'
import { BEFORE_DAY, TODAY, NEXT_DAY } from '../../../util/const'
import moment from 'moment'
import Report from './report'
import { CLUB_ID } from '../../ClubBusiness/constants'
const { RangePicker } = DatePicker

export default class extends React.Component {
  state = {
    size: TODAY,
    visible: false,
    loading: false,
    radioValue: 2,
  }
  componentDidMount() {
    this.props.fetchTimePeriod(TODAY) //默认值显示今日
  }

  onChange = (value, dateString) => {
    if (value.length > 0) {
      this.props.getPeriod({
        start_time: dateString[0],
        end_time: dateString[1],
      })
    } else {
      this.props.getPeriod({ start_time: null, end_time: null }) //清除
    }
  }

  handleSizeChange = (e) => {
    this.setState({ size: e.target.value })
    this.props.fetchTimePeriod(e.target.value) //时间范围
  }

  disabledDate = (current) => {
    return current >= moment()
  }

  handleButton = () => {
    const data = {
      club_id: sessionStorage.getItem(CLUB_ID),
      st:
        moment(this.props.period.start_time).format('YYYY-MM-DD HH:mm:ss') ||
        '',
      et:
        moment(this.props.period.end_time).format('YYYY-MM-DD HH:mm:ss') || '',
      statisticType: this.state.radioValue,
    }
    this.setState({ loading: true })
    this.props.fetchClubShiftList(data).then((res) => {
      this.setState({ loading: false })
    })
  }

  onTypeEvent = (type) => {
    this.setState({
      radioValue: type,
    })
  }

  render() {
    const { size } = this.state
    const { shiftList, period } = this.props

    const disabledDate = (current) => {
      if (current && this.state.firstSelectedTime) {
        if (
          current.isAfter(
            // moment(this.state.firstSelectedTime).add(1, 'months').add(1, 'days')
            moment(this.state.firstSelectedTime).add(6, 'days')
          )
        ) {
          return true
        }
      }
    }

    const onCalendarChange = (dates, dateStrings, info) => {
      if (dateStrings) {
        this.setState({ firstSelectedTime: dateStrings[0] })
      }
    }

    const onOpenChange = (open) => {
      if (!open) {
        this.setState({ firstSelectedTime: '' })
      }
    }

    return (
      <div>
        <Radio.Group
          value={size}
          onChange={this.handleSizeChange}
          style={{ display: 'block', marginBottom: '1rem' }}
        >
          <Radio.Button value={BEFORE_DAY}>
            <span style={{ fontSize: '14px' }}>&lsaquo;</span>前一日
          </Radio.Button>
          {/* <Radio.Button value="1">昨日</Radio.Button> */}
          <Radio.Button value={TODAY}>今日</Radio.Button>
          <Radio.Button value={NEXT_DAY}>
            后一日<span style={{ fontSize: '14px' }}>&rsaquo;</span>
          </Radio.Button>
        </Radio.Group>
        <RangePicker
          // disabledDate={this.disabledDate}
          format="YYYY-MM-DD"
          placeholder={['开始时间', '结束时间']}
          value={
            period.start_time
              ? [
                  moment(`${period.start_time}`, 'YYYY-MM-DD'),
                  moment(`${period.end_time}`, 'YYYY-MM-DD'),
                ]
              : null
          }
          onChange={this.onChange}
          disabledDate={disabledDate}
          onCalendarChange={onCalendarChange}
          onOpenChange={onOpenChange}
        />
        <NineAndZeroRadio typeEvent={this.onTypeEvent} />
        <div style={{ marginTop: '1rem' }}>
          <Button type="primary" onClick={() => this.handleButton('2')}>
            显示
          </Button>
        </div>

        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Report period={period} shiftList={shiftList} />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubShift/component/shift.js